import React,{Component} from 'react';
import {formatPrice} from '../helpers/helpers'

class LaborEdit extends Component{
    constructor(){
        super();
        //this.handleChange = this.handleChange.bind(this)
        //this.handleChangeN = this.handleChangeN.bind(this)
        this.handleDiscount = this.handleDiscount.bind(this)
        this.state = {
            product : {},
            number : 0,
            discount : 0,
            total : 0,
            pretotal : 0,
            price : 0
        }
        
    }
    /*handleChange(e){
        let product = this.state.product
        let update ={
                ...product,
                [e.target.name] : e.target.value
            }
            this.setState({
                product : update
            })
            
    }
    handleChangeN(e){
        if(this.state.discount > 0){
            let discount = this.state.discount/100
            let data = this.state.product.laborPrice * e.target.value 
            let dis = data -(data * discount)
            
            this.setState({
                total : dis,
                pretotal : data
            })
        }else{
            let data = this.state.product.laborPrice * e.target.value 
            
            this.setState({
                total : data,
                pretotal : data
            })
        }

        this.setState({
                number : e.target.value
            })
    }*/

    handleDiscount(e){
        
        let total = this.state.pretotal
        let discount = e.target.value/100
        let dis = total - (total * discount)
        
            this.setState({
                total : dis
            }) 
            this.setState({
                discount : e.target.value
            })
           
    }

    componentWillMount(){
            //let quantity = (this.props.number)?this.props.number : 0
            
                this.setState({
                    product : this.props.product,
                    discount : (this.props.product.discount)?this.props.product.discount:0,
                    total :(this.props.product.total)?this.props.product.total:0
                    
                })    
            


        
    }
    componentDidUpdate(prevProps,prevState){
        let quan = (this.state.product.number) ? this.state.product.number : 0;
        let laborPrice = (this.props.product.price) ? this.props.product.price : 0;
        //console.log(this.state.product.price)
        if(prevState.product !== this.state.product){
            if(this.state.discount > 0){
                let discount = this.state.discount/100
                let data = laborPrice * this.state.product.number 
                let dis = data -(data * discount)
                
                this.setState({
                    total : dis,
                    pretotal : data,

                })
                console.log("if")
            }else{
                let data = laborPrice * this.state.product.number 
                
                this.setState({
                    total : data,
                    pretotal : data
                })
                console.log("else")
            }
            this.props.setLaborTotal(this.props.index,this.state.total,this.state.discount,this.state.product.name,this.state.product.number,this.state.product.price,this.state.product.unit) 
        }

        if(prevState.total !== this.state.total){
           this.props.setLaborTotal(this.props.index,this.state.total,this.state.discount,this.state.product.name,this.state.product.number,this.state.product.price,this.state.product.unit)  
        }

    }

    componentWillReceiveProps(nextProps){
        if (nextProps.product !== this.props.product){
            this.setState({
                product : nextProps.product
            })

        }
        
    }

    render() {     
                
        return (
            
                    <tr>
                        <td>
                            <p>{this.state.product.name}</p>
                            <input type="hidden" className="form-control" name="name"  value={this.state.product.name} ref={input => this.name = input}  />
                            
                        </td>
                        <td>                             
                            <input type="text" className="form-control" name="number" value={this.state.product.number} ref={input => this.number = input}  />                                                       
                        </td>                       
                        <td>
                            <input type="text" className="form-control" value={this.state.product.price} name="price" ref={input => this.price = input}  />                                                          
                        </td>
                        <td>
                           <input type="text" className="form-control"  name="laborDiscount" ref={input => this.laborDiscount = input} value={this.state.discount} onChange={this.handleDiscount} />
                        </td>                        
                        <td>
                            <p>{formatPrice(this.state.total)}</p>
                            <input type="hidden" className="form-control" value={this.state.total} name="total" ref={input => this.total = input} />
                        </td>
                    </tr>
                
 
        );
    }
}

export default  LaborEdit;


// WEBPACK FOOTER //
// ./src/components/LaborEdit.js